"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevel = void 0;
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["info"] = 0] = "info";
    LogLevel[LogLevel["log"] = 1] = "log";
    LogLevel[LogLevel["warn"] = 2] = "warn";
    LogLevel[LogLevel["error"] = 3] = "error";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
class Logger {
    static debugMode = true;
    static logLevel = LogLevel.info;
    static print(data, type) {
        if (!Logger.debugMode)
            return;
        const c = console;
        c[type](data);
    }
    static log(data) {
        if (Logger.logLevel > LogLevel.log)
            return;
        Logger.print(data, 'log');
    }
    static warn(data) {
        if (Logger.logLevel > LogLevel.warn)
            return;
        Logger.print(data, 'warn');
    }
    static error(data) {
        if (Logger.logLevel > LogLevel.error)
            return;
        Logger.print(data, 'error');
    }
    static info(data) {
        if (Logger.logLevel > LogLevel.info)
            return;
        Logger.print(data, 'info');
    }
}
exports.default = Logger;
